<template>
    <div>
      <h4>UPLOAD KYC DOCUMENTS</h4>
      <div class="row">
        <div v-for="(doc, index) in requiredDocs" :key="index" class="col-md-4 p-2">
          <label :for="doc">{{ formatDocName(doc) }}</label>
          <input
            type="file"
            class="form-control"
            :name="doc"
            @change="handleFileUpload($event, doc)"
            required
          />
        </div>
      </div>
      <div class="text-center" style="padding: 10px">
        <p-button type="info" round @click.native.prevent="submitKYC">
          <div class="spinner-grow" role="status" v-if="loading.show === true"></div>
          Submit KYC
        </p-button>
      </div>
    </div>
  </template>
  
  <script>
  import kycDocumentsMap from '../utils/kycDocumentsMap.js';
  
  export default {
    props: {
      businessCategory: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loading: {
          show: false,
        },
      };
    },
    computed: {
      requiredDocs() {
        return kycDocumentsMap.get(this.businessCategory) || [];
      },
    },
    methods: {
      handleFileUpload(event, doc) {
        const file = event.target.files[0];
        this.$emit('file-upload', { doc, file });
      },
      formatDocName(doc) {
        return doc.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
      },
      submitKYC() {
        this.loading.show = true;
        this.$emit('submit-kyc');
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add any specific styles for this component here */
  </style>
  